module.exports = __webpack_public_path__ + "static/media/recherche-small.138e05a0.png";